/** @jsxImportSource @emotion/react */
import InfoTip, {P} from './info-tip';

const CalendarInfo = function () {
  return (
    <InfoTip
      info={
        <section css={{width: 300}}>
          <h3>行事曆</h3>
          <P><li>
            範本行事曆：
            <br/>
            <div className="pl-5">國定假日、休息日、例假日、特殊上班日 的日期依照法規規定，而國定假日為休假日。</div>
          </li></P>
          <P><li>
            時薪人員用行事曆：
            <br/>
            <div className="pl-5">國定假日、休息日、例假日、特殊上班日 的日期依照法規規定，而國定假日當日可排班，並依照薪資類別，時薪人員薪資依當日上班時數*200%。</div>
          </li></P>
          <P><li>
            空白行事曆（排班用）：
            <br/>
            <div className="pl-5">適用於排班性質，國定假日、休息日、例假日、月休可自由排定。</div>
          </li></P>
        </section>
      }
    />
  );
};

export default CalendarInfo;
